module.exports = __webpack_public_path__ + "img/wind-03.fe1f51b3.svg";